import dynamic from 'next/dynamic'

import { useAppUIModal } from '@/contexts/AppUIModalContext'


import { useRouter } from '@/hooks/routes';
import { useMemo, useRef, useEffect } from 'react';
const SignUpModal = dynamic(() => import('./Tips/SignUpModal'), {
  ssr: false,
})

const UpgradePlanModal = dynamic(() => import('./Tips/UpgradePlanModal'), {
  ssr: false,
})

// const UpgradeModal = dynamic(() => import('./Tips/UpgradeModal'), {
//   ssr: false,
// })

const ProfileModal = dynamic(() => import('./Tips/ProfileModal'), {
  ssr: false,
})

const UpgradeModal = dynamic(() => import('./Tips/UpgradeModal'), {
  ssr: false,
})

const PaymentConfirmModal = dynamic(
  () => import('./Tips/PaymentConfirmModal'),
  {
    ssr: false,
  },
)
const ContactUsModal = dynamic(() => import('./Tips/ContactUsModal'), {
  ssr: false,
})

// 下面的open数据要与modals数组中的顺序一致
const modals = [
  {
    component: SignUpModal,
    key: 'SignUp',
  },
  {
    component: UpgradeModal,
    key: 'UpgradeModal',
  },
  {
    component: ProfileModal,
    key: 'ProfileModal',
  },
  {
    component: PaymentConfirmModal,
    key: 'PaymentConfirmModal',
  },
  {
    component: UpgradePlanModal,
    key: 'UpgradePlanModal',
  },
  {
    component: ContactUsModal,
    key: 'ContactUsModal',
  },
]

export default function DynamicTipsModal() {
  const {
    upgradeModal,
    signUp,
    upgradePlan,
    profileModal,
    paymentConfirm,
    contactUsModal,
  } = useAppUIModal()

  const router = useRouter()
  const modalOpens = useMemo(() => {
    return [
      signUp.open,
      upgradeModal.open,
      profileModal.open,
      paymentConfirm.open,
      upgradePlan.open,
      contactUsModal.open,
    ]
  }, [
    signUp.open,
    upgradeModal.open,
    profileModal.open,
    paymentConfirm.open,
    upgradePlan.open,
    contactUsModal.open,
  ])

  const mountedRef = useRef(
    Array.from<number>({ length: modals.length }).fill(0),
  )

  useEffect(() => {
    modalOpens.forEach((item, index) => {
      if (!mountedRef.current[index] && item) {
        mountedRef.current[index] = 1
      }
    })
  }, [modalOpens])

  useEffect(() => {
    function initModal() {
      if (!signUp.data.defaultShowSignUp) {
        signUp.open = false
      }
    }
    router.events.on('routeChangeStart', initModal)
    return () => {
      router.events.off('routeChangeStart', initModal)
    }
  }, [])

  return (
    <>
      {modalOpens.map((item, index) => {
        if (item || mountedRef.current[index]) {
          const Component = modals[index].component
          return <Component key={modals[index].key} />
        }
        return null
      })}
    </>
  )
}
